import React from "react"
import {GetMetaTable} from "./utils/table_helpers";
import {PrintCell} from "./utils/table_formatters";

export default function SampleTableContents(props){
	const rows = props.samples.map((sample, rowNum) => (
		<tr key={`${rowNum}_${sample.sample_type}`}>
			{GetMetaTable(sample.sample_type).map((attribute, attributeNum) => (
				<td key={`${attributeNum}_${attribute.name}`}>{PrintCell(attribute, sample)}</td>
			))}
		</tr>
	))
	
	return(
		<tbody>
			{rows}
		</tbody>
	)
}